// ── overlayBusy ──────────────────────────────────────────────────────────────
// Extracted from Celebration.jsx (2026-08-15 perf pass) so components that need
// isOverlayBusy() SYNCHRONOUSLY — ActivityToast is mounted eagerly, not behind
// NotifLayer's lazy boundary — don't transitively pull in the whole celebration
// toast + confetti component just to read three window flags. Pure, no React.
//
// A full-screen overlay owns the screen — a celebration toast must NOT land on
// top of it. Covers the What's New / update sheet (__nextepModalHold), a card-
// reveal or finale cinematic (__nextepFinaleActive), and the celebration stage's
// active moment / finale chain (__nextepWrapUntil, time-boxed so it can't stick).
export const CELEBRATION_RAIL_ID = 'celebration'

export function isOverlayBusy() {
  if (typeof window === 'undefined') return false
  if (window.__nextepModalHold) return true
  if (window.__nextepFinaleActive) return true
  return !!(window.__nextepWrapUntil && window.__nextepWrapUntil > Date.now())
}
